import { render, staticRenderFns } from "./MinimizedCard.vue?vue&type=template&id=74a9257b&scoped=true&"
import script from "./MinimizedCard.vue?vue&type=script&lang=js&"
export * from "./MinimizedCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74a9257b",
  null
  
)

export default component.exports